<template>
  <section class="reservation-hero">
    <div class="res-card">
      <div class="res-avatar-ring">
        <img src="@/assets/images/favicon.png" alt="أ/طارق المحلاوي" />
      </div>
      <div class="res-name">أ/ طارق المحلاوي</div>
      <div class="res-subtitle">مدرس اللغة العربية للمرحلتين الإبتدائية والإعدادية</div>
      <div class="res-announcement">
        <span class="res-badge">🎉 إعلان</span>
        <p>تم بدء حجز</p>
      </div>
      <router-link to="/reservation" class="btn-primary">📋 احجز مكانك الآن</router-link>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800;900&display=swap');

.reservation-hero {
  min-height: calc(100vh - 140px);
  display: flex; align-items: center; justify-content: center;
  padding: 2rem 1rem;
  background: linear-gradient(135deg,#F5F3EE 0%,#F9F7F2 55%,#F0EDE4 100%);
  font-family: 'Cairo', sans-serif; direction: rtl;
}
.res-card {
  background: rgba(255,255,255,.97); backdrop-filter: blur(24px);
  border-radius: 32px; padding: 3rem 2.5rem;
  box-shadow: 0 30px 80px rgba(0,0,0,.1), 0 0 0 1px rgba(212,175,55,.15);
  display: flex; flex-direction: column; align-items: center;
  gap: 1.25rem; max-width: 460px; width: 100%; text-align: center;
}
.res-avatar-ring {
  width: 100px; height: 100px; border-radius: 50%;
  padding: 4px; background: linear-gradient(135deg,#D4AF37,#8B6508,#F0C040);
  box-shadow: 0 12px 32px rgba(212,175,55,.35);
  display: flex; align-items: center; justify-content: center;
  animation: floatY 3s ease-in-out infinite;
}
.res-avatar-ring img { width:100%; height:100%; border-radius:50%; border:3px solid #fff; }
.res-name {
  font-size:1.75rem; font-weight:800;
  background:linear-gradient(135deg,#D4AF37,#8B6508);
  -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
}
.res-subtitle { font-size:.92rem; color:#6B7280; }
.res-announcement {
  background:rgba(212,175,55,.08); border:1.5px solid rgba(212,175,55,.2);
  border-radius:16px; padding:1rem 1.5rem; width:100%;
}
.res-badge {
  background:linear-gradient(135deg,#D4AF37,#8B6508); color:#0F0F0F;
  padding:.2rem .75rem; border-radius:99px; font-size:.78rem; font-weight:700;
  display:inline-block; margin-bottom:.5rem;
}
.res-announcement p { margin:0; color:#1A1A1A; font-weight:600; font-size:1rem; }
.btn-primary {
  display: inline-flex; align-items: center; justify-content: center; gap: .6rem;
  padding: .9rem 2rem; border-radius: 99px; font-weight: 700; font-size: 1rem;
  text-decoration: none; font-family: 'Cairo', sans-serif; width: 100%;
  background: linear-gradient(135deg,#D4AF37,#8B6508); color: #0F0F0F;
  box-shadow: 0 12px 32px rgba(212,175,55,.3);
  transition: all .3s cubic-bezier(.4,0,.2,1);
}
.btn-primary:hover { transform: translateY(-3px); box-shadow: 0 20px 50px rgba(212,175,55,.45); color: #0F0F0F; }
@keyframes floatY { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
</style>
